import { formatDistanceStrict, format, parse, parseISO } from 'date-fns';
export { addDays } from 'date-fns';

export const now = () => new Date();

export const getElapsedTime = (timeString) => {
  if (!timeString) {
    return null;
  }
  return `${formatDistanceStrict(now(), new Date(timeString))} ago`;
};

export const MMDDYYYY = (timeString) => {
  if (!timeString) {
    return null;
  }
  return format(new Date(timeString), 'MM/dd/yyyy');
};

export const MMMMYYYY = (timeString) => {
  if (!timeString) {
    return null;
  }
  return format(new Date(timeString), 'MMMM yyyy');
};

export const HHMM = (timeString) => {
  if (!timeString) {
    return null;
  }
  return format(new Date(timeString), 'h:mm a');
};

// Uses parseISO (parses a date-only string as local midnight) rather than
// new Date (parses it as UTC midnight, which shifts a birthdate back a day
// in any timezone behind UTC) -- for a date of birth, being off by a day
// isn't acceptable the way it might be for a "verified on" timestamp.
export const MMMMDYYYY = (timeString) => {
  if (!timeString) {
    return null;
  }
  return format(parseISO(timeString), 'MMMM d, yyyy');
};

export const MMMDYYYY = (timeString) => {
  if (!timeString) {
    return null;
  }
  return format(new Date(timeString), 'MMM d, yyyy');
};

export const YYYYMMDD = (timeString) => {
  if (!timeString) {
    return null;
  }
  return format(new Date(timeString), 'yyyy-MM-dd');
};

export const parseMMDDYYYY = (input) => {
  if (!input) {
    return null;
  }

  return parse(input, 'MM/dd/yyyy', now());
};
